import { useEffect, useRef, useState } from 'react';
import { DTOgetOrderDetailedData, ORDER_STATUS } from '../../../../../types/orders';
import BillingDataTab from '../../../../../components/BillingDataTab/BillingDataTab';
import { TAX_MANAGEMENT_OPTIONS } from '../../../../../types/global';
import { getCountryDataFromCode } from '../../../../../utils/getCountries';
import { ICountryDetail } from '../../../../../types/countries';
import PurchaseOrderSection from '../../../../../components/PurchaseOrderSection/PurchaseOrderSection';
import InvoiceSectionOfBillingTab from 'components/InvoiceSectionOfBillingTab/InvoiceSectionOfBillingTab';
import './Tab3Billing.scss';

const Tab3Billing = ({
  updateOrderDetailsInternalCard,
  updateWithoutLoaders,
  listOfCountries,
  orderDetailedData,
  onshowUpdateCreditModal
}: {
  updateOrderDetailsInternalCard: () => void;
  updateWithoutLoaders?: () => void;
  listOfCountries: ICountryDetail[];
  orderDetailedData: DTOgetOrderDetailedData;
  onshowUpdateCreditModal?: () => void;
}) => {
  const [defaultInvoiceNumber, setDefaultInvoiceNumber] = useState<string | null>(null);
  const [emissionDateValue, setEmissionDateValue] = useState<string | null>(null);
  const [isInvoiceDataUpdated, setIsInvoiceDataUpdated] = useState<boolean>(false);
  const [billingCountry, setbillingcountry] = useState<ICountryDetail>();
  const hasIVARef = useRef<boolean>(false);

  const { billingData, orderId, invoiceNumber, billingMethod, purchaseOrderUrl, invoiceEmissionDate } =
    orderDetailedData || {};

  const { taxManagementName, billingCountry: billingCountryCode, billingProvider } = billingMethod || {};

  const showPurchaseOrderSection =
    !!orderDetailedData?.purchaseOrder || !!orderDetailedData?.generalData?.orgData?.requiresPO;

  useEffect(() => {
    const taxManagementOptionsWithVat = [
      TAX_MANAGEMENT_OPTIONS.BREAK_DOWN_ECOMMERCE_TAX,
      TAX_MANAGEMENT_OPTIONS.COMPLETE_TAXES_AFTER_ORDER_CREATION
    ];
    hasIVARef.current = taxManagementOptionsWithVat.includes(taxManagementName as TAX_MANAGEMENT_OPTIONS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxManagementName]);

  useEffect(() => {
    setDefaultInvoiceNumber(invoiceNumber || null);
  }, [invoiceNumber]);

  useEffect(() => {
    setEmissionDateValue(invoiceEmissionDate || null);
  }, [invoiceEmissionDate]);

  useEffect(() => {
    if (!isInvoiceDataUpdated) return;
    setIsInvoiceDataUpdated(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultInvoiceNumber, emissionDateValue]);

  useEffect(() => {
    if (!listOfCountries?.length || !billingCountryCode) return;
    const newBillingCountry = getCountryDataFromCode(billingCountryCode, listOfCountries);
    if (!newBillingCountry) return;
    setbillingcountry(newBillingCountry);
  }, [listOfCountries, billingCountryCode]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="tab3Billing">
      <BillingDataTab
        updateWithoutLoader={updateWithoutLoaders}
        billingData={billingData}
        orderData={orderDetailedData}
        orderPaymentData={orderDetailedData?.generalData?.paymentData}
      />
      {/*CAMBIAR-JC: CAMBIAR POR COMPONENTE EN INTERTA DE BILLINGDATATAB */}
      <InvoiceSectionOfBillingTab
        orderId={Number(orderId)}
        companyName={billingMethod?.beneficiary || ''}
        emissionCountry={billingCountry?.name || ''}
        emissionCountryFlag={billingCountry?.flag || ''}
        billingCountry={billingCountry}
        hasIVA={hasIVARef.current}
        billingProvider={billingProvider}
        variant="order"
        needInvoice={orderDetailedData?.needInvoice || false}
      />
      {showPurchaseOrderSection && (
        <PurchaseOrderSection
          solutionType={'order'}
          solutionId={orderId || undefined}
          reloadDataCallback={updateWithoutLoaders}
          currentPurchaseOrder={orderDetailedData?.purchaseOrder}
          purchaseOrderDocumentUrlOrigin={purchaseOrderUrl || ''}
          shouldAutomateBilling={orderDetailedData?.shouldAutomateBilling}
        />
      )}
      <div className="marginAtBottom w-80 h-40" />
    </div>
  );
};

export default Tab3Billing;
